import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en.json';
import pl from './locales/pl.json';

export const SUPPORTED_LANGUAGES = ['pl', 'en'] as const;
export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number];

const STORAGE_KEY = 'schoolcash.language';

function getInitialLanguage(): SupportedLanguage {
  if (typeof window !== 'undefined') {
    const stored = window.localStorage.getItem(STORAGE_KEY);
    if (stored === 'pl' || stored === 'en') {
      return stored;
    }
    if (navigator.language?.toLowerCase().startsWith('en')) {
      return 'en';
    }
  }
  return 'pl';
}

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    pl: { translation: pl },
  },
  lng: getInitialLanguage(),
  fallbackLng: 'pl',
  interpolation: {
    escapeValue: false, // React already escapes against XSS.
  },
});

// Persist the user's choice so it survives reloads.
i18n.on('languageChanged', (lng) => {
  if (typeof window !== 'undefined') {
    window.localStorage.setItem(STORAGE_KEY, lng);
  }
});

export default i18n;
